export default __webpack_public_path__ + "static/media/ZZC_7992.76e5689f.jpg";